import { useQueryCategories } from '../../../services/api/categoriesService';
import { useEffect } from 'react';

export const useCategoriesData = (companyId, open) => {
  const {
    data: categories = [],
    isLoading: isLoadingCategories,
    mutate: mutateCategories,
  } = useQueryCategories(companyId, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  // Processar dados das categorias
  let categoriesData = null;
  try {
    categoriesData = categories?.data;
    if (categoriesData && typeof categoriesData === 'object' && !Array.isArray(categoriesData)) {
      categoriesData = categoriesData.data || [];
    }
  } catch (error) {
    console.error('Error processing categories data:', error);
    categoriesData = [];
  }

  const categoriesArray = Array.isArray(categoriesData) ? categoriesData : [];

  // Forçar busca de categorias quando o dialog abre
  useEffect(() => {
    if (open && companyId && mutateCategories) {
      mutateCategories();
    }
  }, [open, companyId, mutateCategories]);

  return {
    categories: categoriesArray,
    isLoadingCategories,
    mutateCategories,
  };
};
